module.exports = __webpack_public_path__ + "images/report-reminder-icon.2d9ce8e954da403ff5fa4f79a2d3b65e.png";